export const ROUTES = {
    ServiceTypesManagement: 'tservice-types-management',
}